import { addScheduledGroceryToCart } from './addScheduledGroceryToCart';
import { cancelScheduledGrocery } from './cancelScheduledGrocery';
import { createScheduledGrocery } from './createScheduledGrocery';
import { fetchScheduledGroceries } from './fetchScheduledGroceries';
import { fetchScheduledGrocery } from './fetchScheduledGrocery';
import { getScheduledGroceryEstimate } from './getScheduledGroceryEstimate';
import { updateScheduledGrocery } from './updateScheduledGrocery';

export const scheduledGroceryService = {
  addScheduledGroceryToCart,
  cancelScheduledGrocery,
  createScheduledGrocery,
  fetchScheduledGroceries,
  fetchScheduledGrocery,
  getScheduledGroceryEstimate,
  updateScheduledGrocery,
};
